<template>
  <section class="has-background-primary has-text-white is-absolute xy-l-0 xy-t-0 xy-r-0 m-t--20">
    <div class="is-flex is-flex-centered is-size-7">
      <span>{{ $t('core.logged-in-as') }}</span>
      <span>&nbsp;{{ authUser.contact.fullName }}&nbsp;</span>
      <span>-</span>
      <span>&nbsp;{{ authUser.displayMemberType }}</span>
    </div>
  </section>
</template>

<script>
import { HasAuthUserMixin } from '/@/modules/core/app/mixins/HasAuthUserMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'UserImpersonationBanner',
  mixins: [HasAuthUserMixin]
};
</script>

<style scoped>
section {
  line-height: var(--ce-22px);
}
</style>
